import { render } from "./InboundLeads.vue?vue&type=template&id=edb02cd2&scoped=true"
import script from "./InboundLeads.vue?vue&type=script&lang=js"
export * from "./InboundLeads.vue?vue&type=script&lang=js"

import "./InboundLeads.vue?vue&type=style&index=0&id=edb02cd2&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Leads\\leads-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edb02cd2"]])

export default __exports__